import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __default__ = {
  name: "ForumDashboard"
};
import useSWRV from "swrv";
import { cdate } from "@/utils/cdate";
import { getData } from "@/services/axios";

import { inject } from 'vue';
import { isAuthenticatedKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    // @ts-check
    var isAuthenticated = inject(isAuthenticatedKey);
    var _useSWRV = useSWRV(function () {
        return isAuthenticated.value && "forum-dashboard";
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getData("government_forum", {
                limit: 5
              });
            case 1:
              result = _context.v;
              return _context.a(2, result.items);
          }
        }, _callee);
      })), {
        refreshInterval: 600000,
        // 10分毎
        revalidateOnFocus: false
      }),
      forumList = _useSWRV.data;
    return {
      __sfc: true,
      isAuthenticated: isAuthenticated,
      forumList: forumList,
      cdate: cdate
    };
  }
});